import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InfoBar from '../components/Navigation/InfoBar';
import * as ROUTES from '../constants/routes';
import LogbookOverview from '../components/Tables/Logbook/LogbookOverview';

function LogbookPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<>
			<InfoBar backTitle={t('logbook.logbook')} goBack={() => navigate(ROUTES.SETTINGS)} />
			<LogbookOverview />
		</>
	);
}

export default LogbookPage;
